import { useAuthStore } from '~/store/auth';
import { useApplicationStore } from '~/store/application';
import { firstValueFrom } from 'rxjs';

export default defineNuxtPlugin(async () => {
  const auth = useAuthStore();
  const application = useApplicationStore();

  if (auth.authenticated && !auth.accessToken) {
    await auth.refresh();
  }

  if (auth.authenticated) {
    await firstValueFrom(auth.postLogin());
  }

  application.load();
});
